import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import image from '@coursera/assets/images/Winner_illo.png';
import { Button, CloseCta } from '@coursera/components';

import styles from './plugin-container-success.module.scss';
const cx = classnames.bind(styles);

export const PluginContainerSuccess = ({
  header,
  subheader,
  img,
  nextText,
  backText,
  next,
  back,
  altView,
  children,
}) => {
  const css = cx({
    success: true,
    alt: altView,
    custom: !!children,
  });

  return (
    <>
      <section className={css}>
        <header>
          <h1>{header}</h1>
          <p>{subheader}</p>
        </header>
        {children || <img src={img ? img : image} alt="Complete image" />}
      </section>
      <Button.Container fixed>
        {!!back && (
          <Button onClick={back} variant="outline">
            {backText}
          </Button>
        )}
        <Button variant="outline" onClick={() => next()}>
          {nextText}
        </Button>
      </Button.Container>
      <CloseCta />
    </>
  );
};

PluginContainerSuccess.propTypes = {
  altView: PropTypes.bool,
  back: PropTypes.func,
  backText: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.string,
  img: PropTypes.any,
  next: PropTypes.func,
  nextText: PropTypes.string,
  subheader: PropTypes.string,
};

PluginContainerSuccess.defaultProps = {
  altView: false,
  backText: 'Go back',
  nextText: 'Start over',
};
